import '../css/app.css';
import './bootstrap';

import { createInertiaApp } from '@inertiajs/react';
import { resolvePageComponent } from 'laravel-vite-plugin/inertia-helpers';
import { createRoot } from 'react-dom/client';
import { ThemeSwitcherProvider } from './Context/ThemeSwitcherContext';

const appName = import.meta.env.VITE_APP_NAME || 'Laravel';

createInertiaApp({
	title: (title) => `Tamaro - ${title}`,
	resolve: (name) =>
		resolvePageComponent(
			`./Pages/${name}.jsx`,
			import.meta.glob('./Pages/**/*.jsx'),
		),
	setup({ el, App, props }) {
		const root = createRoot(el);

		root.render(
			<ThemeSwitcherProvider>
				<App {...props} />
			</ThemeSwitcherProvider>
		);
	},
	progress: {
		color: '#4B5563',
	},
});
